import bosanski from './lang-bs'
import english from './lang-en'

export default {
  'bs': bosanski,
  'en': english
}